import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay, EffectFade} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import {parents} from "./utilities";

(() => {
    const swiperItems = document.querySelectorAll('.swiper');
    if (swiperItems.length) {
        swiperItems.forEach(swiperItem => {
            const dataSwiperAttributes = swiperItem.dataset.swiper;
            const dataSwiper = dataSwiperAttributes ? JSON.parse(dataSwiperAttributes) : null
            const dataSwiperOptions = {
                modules: [],
                allowTouchMove: dataSwiper?.allowTouchMove ?? true,
                autoHeight: dataSwiper?.autoHeight ?? false,
                autoplay: dataSwiper?.autoplay ?? {delay: 2000},
                breakpoints: dataSwiper?.breakpoints ?? null,
                centeredSlides: dataSwiper?.centeredSlides ?? false,
                effect: dataSwiper?.effect ?? 'slide',
                keyboard: dataSwiper?.keyboard ?? {},
                loop: dataSwiper?.loop ?? false,
                navigation: dataSwiper?.navigation ?? {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
                pagination: dataSwiper?.pagination ?? {el: ".swiper-pagination", clickable: true},
                slidesPerGroup: dataSwiper?.slidesPerGroup ?? 1,
                slidesPerView: dataSwiper?.slidesPerView ?? 1,
                spaceBetween: dataSwiper?.spaceBetween ?? 0,
                speed: dataSwiper?.speed ?? 1200,
            };
            if (swiperItem.hasAttribute('data-swiper-autoplay')) {
                dataSwiperOptions.modules.push(Autoplay);
            }
            if (dataSwiper?.hasOwnProperty('effect') && dataSwiper.effect === 'fade') {
                dataSwiperOptions.modules.push(EffectFade);
                dataSwiperOptions.fadeEffect = {crossFade: true}
            }
            if (swiperItem.hasAttribute('data-swiper-navigation')) {
                dataSwiperOptions.modules.push(Navigation);
            }
            if (swiperItem.hasAttribute('data-swiper-pagination')) {
                dataSwiperOptions.modules.push(Pagination);
            }

            // Swiper init
            const swiperItemObject = new Swiper(swiperItem, dataSwiperOptions);

            // Slider case
            const sliderSlideTriggers = document.querySelectorAll('.slider-slide__trigger');
            if (swiperItem.classList.contains('slider') && sliderSlideTriggers?.length) {
                /**
                 * Custom slider navigation + autoplay
                 */
                document.body.addEventListener('click', (e) => {
                    if (e.target.closest('.slider-slide__trigger')) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        const target = e.target;
                        const index = target.dataset.index;
                        const slider = parents(target, '.slider');
                        slider[0].swiper.slideTo(index);
                        slider[0].swiper.autoplay.start();
                    }
                });
                /**
                 *  Handle title item active class
                 */
                swiperItemObject.on('slideChange', function (swiper) {
                    swiper.el.querySelector('li.active')?.classList.remove('active');
                    let currentSlide = swiper.slides[swiperItemObject.activeIndex];
                    let currentSlideListItems = currentSlide.querySelectorAll('li');
                    currentSlideListItems[swiperItemObject.activeIndex].classList.add('active');
                });
            }
        });
    }
})()